import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { Badge } from '@ionic-native/badge/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppVersion } from '@ionic-native/app-version/ngx';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import { QRScanner } from '@ionic-native/qr-scanner/ngx';
import { APP_INITIALIZER } from '@angular/core';
import { BrandsService} from './services/brands/brands.service';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule} from './components/components.module';
import { RestangularModule } from 'ngx-restangular';
import { Router } from '@angular/router';
import {AppSettings} from './app.settings';
import {ApiService} from './services/api/api.service';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { Ionic4DatepickerModule } from '@logisticinfotech/ionic4-datepicker';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {HttpCacheService} from './services/http-cache/http-cache.service';
import {CachingInterceptor} from './interceptors/http-interceptor';
import {Contacts} from '@ionic-native/contacts/ngx';
import {OverlayModule} from '@angular/cdk/overlay';
// import {GeofenceService} from './services/geofence/geofence.service';

function RestangularConfigFactory (RestangularProvider, router ) {
  function repeatRequest(response, subject, responseHandler) {
    setTimeout(_ => {
      response.repeatRequest(response.request).subscribe(
          res => { ApiService.hideWaiting(); responseHandler(res); },
          err => {
            if (err.status === 0) {
              repeatRequest(response, subject, responseHandler);
            } else {
              subject.error(err);
            }
          }
      );
    }, 1000);
  }
  RestangularProvider.setBaseUrl(AppSettings.API_ENDPOINT);
  RestangularProvider.addErrorInterceptor((response, subject, responseHandler) => {
    ApiService.spinnerDecrement();
    if (response.status === 0) {
      // no network connection
      // ApiService.showWaiting('Waiting for network connection...');
      repeatRequest(response, subject, responseHandler);
      return false;
    }
    if (response.status === 401) {
      router.navigate(['']);
      return false;
    }  else {
      return true;
    }
  });

  RestangularProvider.addResponseInterceptor((data, operation, what, url, response) => {
    ApiService.spinnerDecrement();
    ApiService.hideWaiting();
    return data;
  });

  RestangularProvider.setRequestInterceptor(function(elem, operation) {
    ApiService.spinnerIncrement();
    return elem;
  });

}

export function appInit(appConfigService: BrandsService) {
  return () => appConfigService.init();
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ComponentsModule,
    HttpClientModule,
    Ionic4DatepickerModule,
    RestangularModule.forRoot([Router], RestangularConfigFactory),
    AngularFireModule.initializeApp(AppSettings.getFirebaseConfig()),
    AngularFirestoreModule,
    OverlayModule,
  ],
  providers: [
    // StatusBar,
    // SplashScreen,
    QRScanner,
    BarcodeScanner,
    AppVersion,
    Badge,
    Contacts,
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    HttpCacheService,
    {provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true},
    BrandsService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      deps: [BrandsService, HttpClient, AppVersion],
      multi: true
    },
  ],
  bootstrap: [AppComponent],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {}
